










import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import ServerError from '@/utils/server_error'
import userStore from '@/modules/auth/auth.store'
import { BaseResponse, ResponseStatus, MemberAPI } from '@/api/member'

@Component
export default class MemberVerify extends Vue {
  userModule = getModule(userStore, this.$store)
  loading: boolean = false
  showMessage: boolean = false

  get userId() {
    return this.userModule.userId
  }

  get token() {
    return this.$route.params.token
  }

  get hasLoggedIn() {
    return this.userModule.hasLoggedIn
  }

  async verifyEmail() {
    if (!this.hasLoggedIn) {
      this.$toast.error('Please login first')
    } else {
      /*
      try {
        const res = await MemberAPI.verifyEmail(this.userId, this.token)

        if (res.data.status !== ResponseStatus.Ok) {
          this.$toast.error(res.data.message as string)
        } else {
          this.showMessage = true
          this.$toast.info('successful')
        }
      } catch (err) {
        if (err instanceof ServerError) {
          this.$toast.error(err.getMessage())
        } else {
          this.$toast.error('System error. Please try again later.')
          console.error(err)
        }
      } finally {
        this.loading = false
      }
      */
    }
  }

  @Watch('hasLoggedIn')
  onLoginStateChanged() {
    this.verifyEmail()
  }

  /* mounted */
  mounted() {
    this.verifyEmail()
  }
}
